import React, { Component, useState } from 'react'
import parse from 'html-react-parser'
import { Table } from 'reactstrap';
import config from './config-helper';

export class Balance extends Component {
    constructor(props) {
        super(props);
        props.location.state.IsPaymentDisplayed = false;
        this.state = props.location.state;
        this.isPositiveBalance = this.state.IsPositiveBalance;
        this.isCriminalSummon = this.state.IsCriminalSummon;
    }

    RedirectToLandingPage(e) {
        e.preventDefault();
        window.location.href = "/Landing";
    }

    render() {


        const MerchantID = config.MERCHANT_ID;
        const APP_BASE_URL = config.CLIENT_BASE_URL;
        const responseURL = APP_BASE_URL + '/Realex';
        const REALEX_PUBLIC_PAYMENT_URL = config.REALEX_PUBLIC_PAYMENT_URL;
        const amount = this.state.AmountForRealex;
        const amountToDisplay = this.state.BalanceAmount;
        if (this.isCriminalSummon) {
            return (
                <div>
                    <div className="col criminalSummon" tabIndex="0">
                        <label>The reference number you have entered is correct but requires you to contact Pierse Fitzgibbon Solicitors
                            directly on 081 8313 100 or by email at <a href="mailto:nralegal@pierse.ie">nralegal@pierse.ie</a></label>
                    </div>
                    <div className="col">
                        <button className="btn btn-secondary" aria-label="Return Button" onClick={this.RedirectToLandingPage}>Return</button>
                        <br />
                        <span className="font-weight-bold font-italic" tabIndex="0">Scrios Amach</span>
                    </div>
                </div>
            );
        }
        else if (this.isPositiveBalance && this.state.ResponseError) {
            return <div className="col" tabIndex="0" role="error">
                <label>  {parse(this.state.ResponseError)} </label>
            </div>
        }
        return (
            <div>
                <div style={{ display: this.state.IsPaymentDisplayed ? "none" : "block" }}>
                    {this.isPositiveBalance && this.state.ConsolidateCaseNumber && <div className="row">
                        <div className="col" tabIndex="0" role="Note">
                            <label>Note: The Reference Number you entered has been consolidated with a number of your other offences into a new case.<br />
                                Please use the new Case Reference Number in any future dealings with Pierse Fitzgibbon Solicitors on this matter.
                                <br /><br /><i>Nota: Ta an uimhir thagartha ata taifeadta agat go dti seo comhdhluite le do chionta eile agus iad anois i gcas nua.
                                    <br />Mar sin, as seo amach usaid an uimhir thagartha nua maidir leis an abhar seo le Pierse Fitzgibbon.</i> </label>
                        </div>
                    </div>}
                    <div className="row">
                        <div className="col-md-4">
                            <label className="font-weight-bold" tabIndex="0">Reference Number:<br /><i>Uimhir Thagartha:</i> </label>
                        </div>
                        <div className="col" tabIndex="0">
                            <label >{this.state.ConsolidateCaseNumber ? this.state.ConsolidateCaseNumber : this.state.CaseNumber}</label>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label className="font-weight-bold" tabIndex="0">Your outstanding balance is:<br /><i>An t-iarmhéid gan íoc agat ná:</i></label>
                        </div>
                        <div className="col">
                            <label tabIndex="0">€ {amountToDisplay}</label>
                        </div>
                    </div>
                    {
                        !this.isPositiveBalance &&
                        <div>
                            <div className="row">
                                <div className="col-md-4">
                                    <label className="font-weight-bold" tabIndex="0"> {parse(this.state.ResponseError)}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <button className="btn btn-secondary" aria-label="Return Button" onClick={this.RedirectToLandingPage}>Return</button>
                                    <br />
                                    <span className="font-weight-bold font-italic" tabIndex="0">Scrios Amach</span>
                                </div>
                            </div>
                        </div>
                    }
                    {this.isPositiveBalance &&
                        <form action={REALEX_PUBLIC_PAYMENT_URL} method="POST" target="targetIframe">
                            <input type="hidden" name="TIMESTAMP" value={this.state.Timestamp} />
                            <input type="hidden" name="MERCHANT_ID" value={MerchantID} />
                            <input type="hidden" name="ACCOUNT" value="internet" />
                            <input type="hidden" name="ORDER_ID" value={this.state.PaymentID} />
                            <input type="hidden" name="AMOUNT" value={amount.toString()} />
                            <input type="hidden" name="CURRENCY" value="EUR" />
                            <input type="hidden" name="AUTO_SETTLE_FLAG" value="1" />
                            <input type="hidden" name="COMMENT1" value="Mobile Channel" />
                            <input type="hidden" name="HPP_VERSION" value="2" />
                            <input type="hidden" name="HPP_CHANNEL" value="ECOM" />
                            <input type="hidden" name="HPP_LANG" value="en" />
                            <input type="hidden" name="MERCHANT_RESPONSE_URL" value={responseURL} />
                            <input type="hidden" name="CARD_PAYMENT_BUTTON" value="Pay Now" />
                            <input type="hidden" name="CUST_NUM" value={(this.state.ConsolidateCaseNumber ? this.state.ConsolidateCaseNumber : this.state.CaseNumber)} />
                            <input type="hidden" name="CASE_NUMBER" value={(this.state.ConsolidateCaseNumber ? this.state.ConsolidateCaseNumber : this.state.CaseNumber)} />
                            <input type="hidden" name="SHA1HASH" value={this.state.Sha1Hash} />
                            {/*Begin HPP additional Fields*/}
                            <input type="hidden" name="HPP_CAPTURE_ADDRESS" value="true" />
                            <input type="hidden" name="HPP_REMOVE_SHIPPING" value="true" />
                            <input type="hidden" name="HPP_DO_NOT_RETURN_ADDRESS" value="false" />
                            <input type="hidden" name="HPP_BILLING_COUNTRY" value="372" />
                            {/**End HPP additional Fields*/}

                            <div className="row">

                                <div className="col-md-6 btn-cancel">
                                    <button className="btn btn-outline-secondary" aria-label="Cancel Button" onClick={this.RedirectToLandingPage}>Cancel</button>
                                    <br />
                                    <span className="font-weight-bold font-italic" tabIndex="0">Scrios Amach</span>
                                </div>
                                <div className="col-md-6">
                                    <button type="Submit" className="btn btn-secondary" aria-label="Make Payment Button" onClick={() => this.setState({ IsPaymentDisplayed: true })}>Make Payment</button>
                                    <br />
                                    <span className="font-weight-bold font-italic" tabIndex="0">Déan Íocaíocht</span>
                                </div>
                            </div>
                        </form>
                    }
                    {this.state.CasesDetails && this.state.CasesDetails.length > 1 &&
                        <div className="row">
                            <div className="col charge-breakdown">
                                <label className="font-weight-bold" tabIndex="0">Charge Breakdown</label>
                                <div className="TVNTable">
                                    <Table striped>
                                        <thead style={{ color: 'white', backgroundColor: "#292526" }}>
                                            <tr>
                                                <td tabIndex="0">Case Number</td>
                                                <td tabIndex="0">License Plate</td>
                                                <td tabIndex="0">Balance</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.CasesDetails.map((item, key) => {
                                                return (
                                                    <tr key={key}>
                                                        <td tabIndex="0">{item.CaseNumber}</td>
                                                        <td tabIndex="0">{item.LicensePlate}</td>
                                                        <td tabIndex="0">€{item.Balance ? item.Balance : "0.00"}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div tabIndex="0" style={{ display: this.state.IsPaymentDisplayed ? "block" : "none" }}>
                    <iframe width="100%" height="600" id="targetIframe" frameBorder="0" name="targetIframe"></iframe>

                </div>
            </div>
        );
    }
}